import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  signOut as firebaseSignOut,
  onAuthStateChanged as firebaseOnAuthStateChanged,
} from 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

import GoogleIcon from '../images/google.svg?react';
import FacebookIcon from '../images/facebook.svg?react';

const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY?.trim();

export const firebaseApp = firebaseApiKey ? initializeApp({
  apiKey: firebaseApiKey,
  authDomain: 'eamsportal.firebaseapp.com',
  projectId: 'eamsportal',
  storageBucket: 'eamsportal.firebasestorage.app',
  messagingSenderId: '45396866895',
  appId: '1:45396866895:web:c884caa21fab1bc6f0b73a',
  measurementId: 'G-D6VXT9HXQK',
}) : null;

export const auth = firebaseApp ? getAuth(firebaseApp) : null;

export const signOut = (authInstance) => (
  authInstance ? firebaseSignOut(authInstance) : Promise.resolve()
);

export const onAuthStateChanged = (authInstance, nextOrObserver) => (
  authInstance ? firebaseOnAuthStateChanged(authInstance, nextOrObserver) : () => {}
);

export const getUiConfig = ({
  signInSuccessWithAuthResult,
  uiShown,
  showGoogleLogin = false,
  showFacebookLogin = false,
  fullLabel = 'Sign in with Google',
  fullLabelFacebook = 'Sign in with Facebook',
}) => ({
  callbacks: {
    signInSuccessWithAuthResult,
    uiShown,
  },
  signInFlow: 'popup',
  signInOptions: [
    showGoogleLogin && {
      provider: GoogleAuthProvider.PROVIDER_ID,
      fullLabel: fullLabel,
    },
    showFacebookLogin && {
      provider: FacebookAuthProvider.PROVIDER_ID,
      fullLabel: fullLabelFacebook,
      scopes: ['email', 'public_profile'],
    },
  ],
});

export const ui =
  auth
    ? firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(auth)
    : { start: () => {}, reset: () => {} };

export const PROVIDER_CONFIG = {
  'google.com': {
    name: 'Google',
    icon: GoogleIcon,
  },
  'facebook.com': {
    name: 'Facebook',
    icon: FacebookIcon,
  },
};
